import React from "react";
import {PerfomanceSetPoints} from "../../../SUMMARY/SummaryModel";

// 一覧参照用(実績情報あり)
export type AdvertisementWithPerformance = {
    adAccountId: number,
    campaignId: number,
    campaignName: string,
    campaignStatus: number,
    adGroupId: number,
    adGroupName: string,
    adGroupStatus: number,
    creativeId: number,
    creativeName: string,
    creativeStatus: number,
    displayParentArchiveCode: number,
    adAssetId: number,
    adAssetName: string,
    trackingParam: string,
    trackingParamAdGroup: string,
    reviewStatus: number,
    denialReason: number,
    denialReasonDetail: string,
    createdDatetime: string,
    updatedDatetime: string,
    lastUpdatedUserId: string,
    lastUpdatedVer: string,
    achievement: Achievement,
    assetImageUrl: string,
    campaignType: number,
    cost: number;
    imp: number;
    click: number;
    ctr: number;
    cpc: number;
    cpm: number;
    trackingPointCvTotal: number;
    trackingPointCvClickThrough: number;
    trackingPointCvAssist: number;
    trackingPointCpaTotal: number;
    trackingPointCpaClickThrough: number;
    trackingPointCpaAssist: number;
    trackingPointCvrTotal: number;
    trackingPointCvrClickThrough: number;
    trackingPointCvrAssist: number;
    trackingPointCvClickThroughSetPoints: PerfomanceSetPoints[];
    trackingPointCvAssistSetPoints: PerfomanceSetPoints[];
    trackingPointCpaClickThroughSetPoints: PerfomanceSetPoints[];
    trackingPointCvrClickThroughSetPoints: PerfomanceSetPoints[];
}

// 一覧参照用
export type Advertisement = {
    adAccountId: number,
    campaignId: number,
    campaignName: string,
    campaignStatus: number,
    adGroupId: number,
    adGroupName: string,
    adGroupStatus: number,
    creativeId: number,
    creativeName: string,
    creativeStatus: number,
    adAssetId: number,
    adAssetName: string,
    trackingParam: string,
    trackingParamAdGroup: string,
    reviewStatus: number,
    denialReason: number,
    denialReasonDetail: string,
    createdDatetime: string,
    updatedDatetime: string,
    lastUpdatedUserId: string,
    lastUpdatedVer: string,
    achievement: Achievement,
    assetImageUrl: string,
    campaignType: number,
}

export type AdvertisementCreate = {
    adAccountId: number,
    campaignId: number,
    adGroupId: number,
    creativeName: string,
    creativeStatus: number,
    adAssetId: number,
    trackingParam: string,
    userId: string,
}

export type AdvertisementUpdate = {
    adAccountId: number,
    creativeId: number,
    creativeName: string,
    creativeStatus: number,
    adAssetId: number,
    trackingParam: string,
    userId: string,
    lastUpdatedVer: string,
}

// 一覧参照用
export type Achievement = {
    id: number,
    cost: number,
    imp: number,
    click: number,
}

export const initAchievement = {
    id: 0,
    cost: 0,
    imp: 0,
    click: 0,
}
